"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductStatus = void 0;
var ProductStatus;
(function (ProductStatus) {
    ProductStatus[ProductStatus["PreLaunch"] = 10] = "PreLaunch";
    ProductStatus[ProductStatus["Teaser"] = 20] = "Teaser";
    ProductStatus[ProductStatus["Launch"] = 30] = "Launch";
    ProductStatus[ProductStatus["ActiveNormal"] = 40] = "ActiveNormal";
    ProductStatus[ProductStatus["ActiveNoTestDrive"] = 45] = "ActiveNoTestDrive";
    ProductStatus[ProductStatus["OutOfProduction"] = 50] = "OutOfProduction";
    ProductStatus[ProductStatus["OutOfProductionNoTestDrive"] = 55] = "OutOfProductionNoTestDrive";
    ProductStatus[ProductStatus["Inactive"] = 60] = "Inactive";
})(ProductStatus = exports.ProductStatus || (exports.ProductStatus = {}));
var defaultProductStatus = ProductStatus.ActiveNormal;
exports.default = defaultProductStatus;
//# sourceMappingURL=productStatus.js.map